const isCmsTag = (val) => !!val && typeof val === "object" && "isCmsContent" in val && val.isCmsContent === true && "key" in val && typeof val.key === "string";
export {
  isCmsTag
};
